import { ChecklistBlockConfigurationRecord } from "models/view-models/block-configurations/checklist-block-configuration-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface ChecklistBlockConfigurationUpdatePathParams {
    configurationId: number;
}

export interface ChecklistBlockConfigurationUpdatePutParams {
    isNumbered: boolean;
    usesCustomStatuses: boolean;
}

const resourceEndpoint: string =
    "blocks/configurations/checklist/:configurationId";
const resourceType = ChecklistBlockConfigurationRecord;

const ChecklistBlockConfigurationService = {
    useUpdate: ServiceHookFactory.useUpdateFromPutParams<
        ChecklistBlockConfigurationRecord,
        ChecklistBlockConfigurationUpdatePutParams,
        ChecklistBlockConfigurationUpdatePathParams
    >(resourceType, resourceEndpoint),
};

export default ChecklistBlockConfigurationService;
